;(function($, window, document){
    window.ProjectInMind = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'displayFormChoices', 'hideFormChoices', 'selectDropdownChoice', 'keypressHandler', 'selectInputValue', 'initInputValue');

            this.addEvents();
            this.initInputValue();
        },
        addEvents: function() {
            this.$('a').on('click', this.displayFormChoices);
            this.$('.user-data li').on('click', this.selectDropdownChoice);
            this.$('.user-data button').on('click', this.selectInputValue);
        },
        initInputValue: function(){
            var view = this;
            this.$('.user-data').each(function(index,value){
                //duplicates values from the text to the inputs
                var getTextValue = view.$('.content-wrapper p a[data-content="' + $(value).attr('data-content') + '"] .value').text();

                //input that can be modified by the user
                if($(value).find('input').length != 0){
                    $(value).find('input').val(getTextValue);
                }

                //hidden inputs
                view.$('input[name=' + $(value).attr('data-content') + ']').val(getTextValue);

            });
        },
        displayFormChoices: function(e){
            //add event to close popup once we click anywhere in the website
            $('body').on('click', this.hideFormChoices);
            $(window).on('keydown', this.keypressHandler);

            e.preventDefault();
            e.stopPropagation();

            //hide previously active elements and display the one clicked by the user
            this.$el.addClass('active');
            this.$('.user-data.active').removeClass('active');
            this.$('div[data-content="' + $(e.currentTarget).attr('data-content') + '"]').addClass('active');

            //align to the anchor element (30% from the left)
            var posX = $(e.currentTarget).position().left + $(e.currentTarget).width() * 0.3;

            while(posX + this.$('.user-data.active').width() > parseInt(this.$('.section-centered-content .content').outerWidth())){
                posX -= 5;
            }

            //center vertically based off anchor element position, minus half the content height
            var posY = ($(e.currentTarget).position().top +  $(e.currentTarget).height()/2) - parseInt(this.$('.user-data.active').css('height')) /2;

            this.$('.user-data.active').css({'top': posY, 'left': posX});

            if(this.$('.user-data.active input').length != 0){
                this.$('.user-data.active input').focus();
            }
        },
        keypressHandler: function(e){
            if(e.keyCode == 27){
                //escape
                this.hideFormChoices();
            }else if(e.keyCode == 13){
                //enter
                this.$('.user-data.active button').trigger('click');
            }
        },
        hideFormChoices: function(e){
            if(e){
                //do not close the popups if element clicked is the popup itself or one of its children
                if($(e.target).hasClass('user-data') || $(e.target).parents('.user-data').length != 0){
                    return;
                }
            }

            this.$el.removeClass('active');
            $('body').off('click', this.hideFormChoices);
            $(window).off('keydown', this.keypressHandler);
            this.$('.user-data.active').removeClass('active');
        },
        selectDropdownChoice: function(e){
            var dataGroup = $(e.currentTarget).parents('.user-data').attr('data-content');
            var userSelection = $(e.currentTarget).text();
            this.$('.content-wrapper a[data-content="' + dataGroup + '"] .value').html(userSelection);
            this.$('input[name=' + dataGroup + ']').val(userSelection);
            this.hideFormChoices();
        },
        selectInputValue: function(e){
            var dataGroup = $(e.currentTarget).parents('.user-data').attr('data-content');
            var userSelection = parseFloat($(e.currentTarget).parents('.user-data').find('input').val());
            this.$('.content-wrapper a[data-content="' + dataGroup + '"] .value').html(userSelection);
            this.$('input[name=' + dataGroup + ']').val(userSelection);
            this.hideFormChoices();
        }
    });
}(jQuery, window, document));